module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_vm._v("Prediction is very difficult, especially if it’s about the future."), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("—")]), _vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IELS ")]), _vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed32bee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ferocity_00000.vue
// module id = 66
// module chunks = 0